'use client';

import { ReactNode, useRef } from 'react';

import { GridColDef } from '@mui/x-data-grid';
import { useTranslations } from 'next-intl';

import { TradeConditionsSymbol } from '@/api/trade-conditions/types';
import { Container } from '@/blocks/components/Container';
import { DataGridWrapper, useColumnsVisibilityModel, useRowClick } from '@/blocks/components/DataGrid';
import { getColDefMarket } from '@/blocks/components/DataGrid/Asset/columnsDefenitions';
import {
  getColDefFinancingLong,
  getColDefFinancingShort,
  getColDefMakerFee,
  getColDefMinOrderSize,
  getColDefTakerFee,
} from '@/blocks/components/DataGrid/TradeConditions/getColDefTradingFee';
import { VStack } from '@/blocks/components/layout';

import { CryptoFuturesFeesAllMarketsSearch } from '../CryptoFuturesFeesAllMarketsSearch';

export function CryptoFuturesFeesAllMarketsTable({
  markets,
  heading,
}: {
  markets: TradeConditionsSymbol[];
  heading: ReactNode;
}) {
  const tr = useTranslations();
  const { openSignupOnRowClick } = useRowClick();

  const columnsVisibilityModel = useColumnsVisibilityModel({
    mobile: ['name', 'makerFeePct', 'takerFeePct'],
    tablet: ['name', 'makerFeePct', 'takerFeePct', 'minOrderSize'],
    desktop: ['name', 'makerFeePct', 'takerFeePct', 'minOrderSize', 'financingLongPct', 'financingShortPct'],
  });

  const refContainer = useRef<HTMLElement | null>(null);

  const rows = markets;

  const columns: GridColDef<any>[] = [
    getColDefMarket(tr('pages.cryptoFuturesMarkets.sections.markets.table.headers.market')),
    getColDefMakerFee(tr('pages.cryptoFuturesMarkets.sections.markets.table.headers.makerFee')),
    getColDefTakerFee(tr('pages.cryptoFuturesMarkets.sections.markets.table.headers.takerFeeFrom')),
    getColDefMinOrderSize(tr('pages.cryptoFuturesMarkets.sections.markets.table.headers.minOrderSize')),
    getColDefFinancingLong(tr('pages.cryptoFuturesMarkets.sections.markets.table.headers.8hRateLong')),
    getColDefFinancingShort(tr('pages.cryptoFuturesMarkets.sections.markets.table.headers.8hRateShort')),
  ];

  return (
    // @ts-ignore
    <VStack ref={refContainer}>
      {heading}
      <CryptoFuturesFeesAllMarketsSearch />
      <div>
        <Container>
          <DataGridWrapper
            loading={false}
            columns={columns}
            rows={rows}
            onRowClick={openSignupOnRowClick}
            columnVisibilityModel={columnsVisibilityModel}
          />
        </Container>
      </div>
    </VStack>
  );
}
